import React, {useState} from "react";
import DocumentTitle from "react-document-title";
import {Button, Paper} from "@material-ui/core";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {actions as externalOfferActions} from "../../actions/externalOfferActions";
import compose from "recompose/compose";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import ExternalOffersList from "./ExternalOffersList";
import ExternalOfferDialog from "./ExternalOfferDialog";

const ExternalOfferPage = ({list, actions}) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const onCreateHandler = async (data) => {
        setSubmitting(true)
        const result = await actions.create(data);
        setSubmitting(false)
        if (result) {
            actions.loadExternalOffers(1, list.paging.pageSize, list.sortedBy, list)
            setOpenDialog(false)
        }
    };

    return (
        <DocumentTitle title={'Raport formularzu zwrotnego'}>
            <Paper style={{
                marginRight: 60,
                marginLeft: 60,
                marginTop: 80,
                padding: 16,
                display: "flex",
                gap: 16,
                flexDirection: "column"
            }}>
                <div style={{textAlign: 'right', paddingTop: 20}}>
                    <div style={{marginBottom: 10}}>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => setOpenDialog(true)}
                        >
                            Dodaj nową ofertę
                        </Button>
                    </div>
                </div>
                <ExternalOffersList/>
                <ExternalOfferDialog
                    submitting={submitting}
                    loading={false}
                    open={openDialog}
                    onSubmit={onCreateHandler}
                    onCancel={() => setOpenDialog(false)}
                />
            </Paper>
        </DocumentTitle>
    )
}


ExternalOfferPage.propTypes = {
    t: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    list: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const externalOfferState = state.externalOffer;
    return {
        list: externalOfferState.pagedData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(externalOfferActions, dispatch)
    };
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation()
)(ExternalOfferPage);
